import React, { useContext, useState } from "react";
import { IconButton, Box, AppBar, Toolbar, Button, Tooltip, Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import { getCookies, removeCookies } from "../../services/Cookies";
import { logout, setLoggedIn } from "../../store/Slices/userSlice";
import { useDispatch } from "react-redux";
import { ThemeContext } from "../../context/ThemeContext";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import OneClickBtn from '../../assets/oneClick.png'
import BtnTrade from '../../assets/newOrder.png'
import UserMenu from "../menu/UserMenu";
import { useTranslation } from 'react-i18next';
import '../../App.scss'
import { IoIosMenu } from "react-icons/io";
import { FiFileText } from "react-icons/fi";
import { MdAdsClick } from "react-icons/md";
import { setIsOneClick, setChartLayoutType } from "../../store/Slices/watchList";
import { addJournalLog } from "../tab/tabview/journal/addJournalLog";
import { LuLayoutDashboard } from "react-icons/lu";
import { TfiLayoutColumn2, TfiLayoutGrid2, TfiLayoutWidthFull, TfiLayout } from "react-icons/tfi";


const Header = ({ containerRef, openOneClickModal, closeOneClickModal, toggleSymbolPanel, isSymbolPanelVisible, handleOpenOneTradeModal, currentSymbolId, handleOpenNewDashboard }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { userDetail } = useSelector((state) => state.user);
  const client = userDetail || {};
  const { darkMode } = useContext(ThemeContext)
  const { accountId, accountData } = useSelector(state => state.accountSummary)
  const chartLayoutType = useSelector(state => state.watchlist?.chartLayoutType)
  const isOneClick = useSelector(state => state.watchlist?.isOneclick)
  const [isOneClickOpen, setIsOneClickOpen] = useState(false);
  const { t } = useTranslation();
  const accountID = localStorage.getItem('accountID')
  const username = getCookies('username')
  const id = localStorage.getItem('clientId')
  const agreementKey = `oneClickTradingAgreement_${client.id}`;
  const agreement = JSON.parse(localStorage.getItem(agreementKey));
  const [anchorEl2, setAnchorEl2] = useState(null);
  const layoutMenuOpen = Boolean(anchorEl2);
  const handleClickView = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleCloseView = (layoutType) => {
    if (typeof layoutType === 'number') {
      dispatch(setChartLayoutType(layoutType));
    }
    setAnchorEl2(null);
  };

  const handleMenuClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    addJournalLog('logout', `Account ${username}: ${accountID} is logged out`);

    setTimeout(() => {
      removeCookies("username", { path: "/" });
      removeCookies("token", { path: "/" });
      removeCookies("clientId", { path: "/" });
      removeCookies('gmtOffset', { path: '/' });

      localStorage.removeItem(`visibleColumns_${id}`)
      localStorage.setItem("accountID", "");

      dispatch(setLoggedIn(false));
      dispatch(logout());

      window.location.href = "/";
    }, 200);
  };


  const handleFullscreenToggle = () => {
    if (!isFullscreen) {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      }
      setIsFullscreen(true);
    } else {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
      setIsFullscreen(false);
    }
  }

  const toggleOneClickModal = () => {
    if (!agreement?.agreed) {
      openOneClickModal();
      return;
    }
    if (isOneClickOpen) {
      closeOneClickModal();
    } else {
      openOneClickModal();
    }
    setIsOneClickOpen((prev) => !prev);
  };

  const toggleOneClickTrading = () => {
    if (!agreement?.agreed && !isOneClickOpen) {
      openOneClickModal();
    }
    dispatch(setIsOneClick(!isOneClick));
  };

  const imageSrc = darkMode ? '/Vfx-logo_white 1.png' : '/Vfx logo 1.png';
  return (
    <>
      <AppBar elevation={0} sx={{ backgroundColor: darkMode ? "var(--background-color)" : 'var(--white)', zIndex: 1250, border: 'none', borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} >
        <Toolbar sx={{ alignItems: "center" }}>
          <Box onClick={handleMenuClick} size="small" sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: '0' }}>
            <IconButton style={{ marginRight: '8px', marginLeft: '10px', }}>
              <IoIosMenu />
            </IconButton>
          </Box>
          <div className="ms-2 flex">
            <a href="https://equitastrader.com/" target="_blank"><img src={imageSrc} alt="logo" style={{ height: '15px' }} /></a>
          </div>
          <Box display='flex' gap={1} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, px: 1 }}>
            {chartLayoutType === 0 && <Tooltip title={!agreement?.agreed ? t("showOneClickModal") : isOneClickOpen ? t("hideOneClickModal") : t("showOneClickModal")}>

              <IconButton onClick={toggleOneClickModal}>
                <img src={OneClickBtn} alt="" width={20} height={13} style={{ filter: agreement?.agreed && isOneClickOpen ? 'grayscale(100%)' : 'none', opacity: agreement?.agreed && isOneClickOpen ? 0.5 : 1, }} />
              </IconButton>
            </Tooltip>}

            <Tooltip title={t('newOrder')}>
              <Button onClick={() => handleOpenOneTradeModal(currentSymbolId)} sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)', fontSize: '0.8rem', display: 'flex', alignItems: 'center', textTransform: 'none' }}>
                <img src={BtnTrade} alt="BtnTrade" width={18} style={{ marginRight: '5px' }} />
                {t('newOrder')}
              </Button>
            </Tooltip>
          </Box>
          <Box display='flex' gap={1} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, px: 1 }}>
            <Tooltip title={isSymbolPanelVisible ? t('hideMarketWatch') : t('showMarketWatch')}>
              <IconButton onClick={toggleSymbolPanel}>
                <FiFileText style={{ fontSize: 18, color: isSymbolPanelVisible ? 'var(--primary)' : 'inherit' }} />
              </IconButton>
            </Tooltip>
          </Box>
          <Box display='flex' gap={1} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, px: 1, }}>
            <Tooltip title={t('layout')}>
              <IconButton onClick={handleClickView}>
                <LuLayoutDashboard style={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
            <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} anchorEl={anchorEl2} open={layoutMenuOpen} onClose={() => handleCloseView()} anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }} transformOrigin={{ vertical: 'top', horizontal: 'left', }} >
              <Box sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)', }} >
                <MenuItem onClick={e => handleCloseView(0)} ><TfiLayoutWidthFull style={{ marginRight: 8 }} /></MenuItem>
                <MenuItem onClick={e => handleCloseView(1)} ><TfiLayoutColumn2 style={{ marginRight: 8 }} /></MenuItem>
                <MenuItem onClick={e => handleCloseView(2)} ><TfiLayoutColumn2 style={{ transform: 'rotate(90deg)' }} /></MenuItem>
                <MenuItem onClick={e => handleCloseView(3)} ><TfiLayout style={{ marginRight: 8, transform: 'rotate(-90deg)' }} /></MenuItem>
                <MenuItem onClick={e => handleCloseView(4)} ><TfiLayout style={{ marginRight: 8, transform: 'rotate(90deg)' }} /></MenuItem>
                <MenuItem onClick={e => handleCloseView(5)} ><TfiLayoutGrid2 style={{ marginRight: 8 }} /></MenuItem>
              </Box>
            </Menu>

          </Box>

          <Box flexGrow={1} />
          <Tooltip title={!isOneClick ? t('defaultView') : t('oneTrading')}>
            <IconButton onClick={toggleOneClickTrading}
            ><MdAdsClick style={{ fontSize: 18, color: !isOneClick ? 'var(--primary)' : 'inherit' }} /></IconButton>
          </Tooltip>

          <Tooltip title={isFullscreen ? t('exitFullscreen') : t('enterFullscreen')}>
            <IconButton onClick={handleFullscreenToggle} >
              {isFullscreen ? <FullscreenExitIcon sx={{ fontSize: 20 }} /> : <FullscreenIcon sx={{ fontSize: 20 }} />}
            </IconButton>
          </Tooltip>


          <UserMenu anchorEl={anchorEl} darkMode={darkMode} id={accountId} client={client} handleClose={handleClose} handleLogout={handleLogout} accountData={accountData} />
        </Toolbar>
      </AppBar>
      {/* {isTradingAccountsOpen && (
        <div style={{ position: 'absolute', top: 80, left: "25%" }}>
          <TradingAccounts onClose={handleCloseTradingAccounts} activeTab={activeTab} />
        </div>
      )} */}

    </>
  );
};

export default Header;
